export const CONTACT_FILTER_GROUPS = [
  {
    id: 'contact_details',
    label: 'Contact Details',
    filters: [
      {
        id: 'contact_type',
        label: 'Contact Type',
        type: 'checkbox',
        options: []
      },
      {
        id: 'title',
        label: 'Title',
        type: 'search',
        options: []
      },
      {
        id: 'company_name',
        label: 'Company',
        type: 'search',
        options: []
      },
      {
        id: 'city',
        label: 'City',
        type: 'search',
        options: []
      },
      {
        id: 'state',
        label: 'State',
        type: 'search',
        options: []
      },
      {
        id: 'zip',
        label: 'Zip',
        type: 'search',
        options: []
      }
    ]
  },
  {
    id: 'contact_info',
    label: 'Contact Info',
    filters: [
      {
        id: 'has_email',
        label: 'Has Email',
        type: 'checkbox',
        options: [
          { value: 'true', label: 'Yes' },
          { value: 'false', label: 'No' }
        ]
      },
      {
        id: 'has_phone',
        label: 'Has Phone',
        type: 'checkbox',
        options: [
          { value: 'true', label: 'Yes' },
          { value: 'false', label: 'No' }
        ]
      },
      {
        id: 'has_street_address',
        label: 'Has Street Address',
        type: 'checkbox',
        options: [
          { value: 'true', label: 'Yes' },
          { value: 'false', label: 'No' }
        ]
      }
    ]
  },
  {
    id: 'activity',
    label: 'Activity',
    filters: [
      {
        id: 'has_transactions',
        label: 'Has Transactions',
        type: 'checkbox',
        options: [
          { value: 'true', label: 'Yes' },
          { value: 'false', label: 'No' }
        ]
      },
      {
        id: 'events_count',
        label: 'Events Attended',
        type: 'range',
        options: []
      }
    ]
  },
  {
    id: 'relationships',
    label: 'Relationships',
    filters: [
      {
        id: 'has_organizations',
        label: 'Has Organizations',
        type: 'checkbox',
        options: [
          { value: 'true', label: 'Yes' },
          { value: 'false', label: 'No' }
        ]
      },
      {
        id: 'has_households',
        label: 'Has Households',
        type: 'checkbox',
        options: [
          { value: 'true', label: 'Yes' },
          { value: 'false', label: 'No' }
        ]
      }
    ]
  },
  {
    id: 'giving_memberships',
    label: 'Giving & Memberships',
    filters: [
      {
        id: 'has_donations',
        label: 'Has Donations',
        type: 'checkbox',
        options: [
          { value: 'true', label: 'Yes' },
          { value: 'false', label: 'No' }
        ]
      },
      {
        id: 'has_soft_credits',
        label: 'Has Soft Credits',
        type: 'checkbox',
        options: [
          { value: 'true', label: 'Yes' },
          { value: 'false', label: 'No' }
        ]
      },
      {
        id: 'has_pledges',
        label: 'Has Pledges',
        type: 'checkbox',
        options: [
          { value: 'true', label: 'Yes' },
          { value: 'false', label: 'No' }
        ]
      },
      {
        id: 'pledge_status',
        label: 'Pledge Status',
        type: 'checkbox',
        options: []
      },
      {
        id: 'has_memberships',
        label: 'Has Memberships',
        type: 'checkbox',
        options: [
          { value: 'true', label: 'Yes' },
          { value: 'false', label: 'No' }
        ]
      },
      {
        id: 'membership_status',
        label: 'Membership Status',
        type: 'checkbox',
        options: []
      }
    ]
  },
  {
    id: 'dates',
    label: 'Dates',
    filters: [
      {
        id: 'created_at',
        label: 'Created Date',
        type: 'date_range',
        options: []
      }
    ]
  }
];

export const getFilterGroupById = (id) => {
  return CONTACT_FILTER_GROUPS.find(group => group.id === id);
};

export const getFilterById = (filterId) => {
  for (const group of CONTACT_FILTER_GROUPS) {
    const filter = group.filters.find(f => f.id === filterId);
    if (filter) {
      return filter;
    }
  }
  return null;
};

export const getActiveFilterCount = (activeFilters) => {
  return Object.values(activeFilters).reduce((count, values) => {
    if (Array.isArray(values) && values.length > 0) {
      return count + 1;
    }
    if (typeof values === 'object' && values !== null && !Array.isArray(values)) {
      const hasValue = Object.values(values).some(v => v !== '' && v !== null && v !== undefined);
      if (hasValue) {
        return count + 1;
      }
    }
    return count;
  }, 0);
};
